var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarkerRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2873_1802)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2873_1802",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.859375C5.79086 0.859375 4 2.65024 4 4.85937V24.2973C4 26.5064 5.79086 28.2973 8 28.2973H15.0471L18.5833 31.727L22.1196 28.2973H28C30.2091 28.2973 32 26.5064 32 24.2973V4.85937C32 2.65024 30.2091 0.859375 28 0.859375H8Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.859375C5.79086 0.859375 4 2.65024 4 4.85937V24.2973C4 26.5064 5.79086 28.2973 8 28.2973H15.0471L18.5833 31.727L22.1196 28.2973H28C30.2091 28.2973 32 26.5064 32 24.2973V4.85937C32 2.65024 30.2091 0.859375 28 0.859375H8Z",
    fill: "#C4391B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0471 28.2973L16.4395 26.8616L15.8576 26.2973H15.0471V28.2973ZM18.5833 31.727L17.1909 33.1627L18.5833 34.5132L19.9758 33.1627L18.5833 31.727ZM22.1196 28.2973V26.2973H21.309L20.7272 26.8616L22.1196 28.2973ZM6 4.85937C6 3.75481 6.89543 2.85938 8 2.85938V-1.14062C4.68629 -1.14062 2 1.54567 2 4.85937H6ZM6 24.2973V4.85937H2V24.2973H6ZM8 26.2973C6.89543 26.2973 6 25.4019 6 24.2973H2C2 27.611 4.68629 30.2973 8 30.2973V26.2973ZM15.0471 26.2973H8V30.2973H15.0471V26.2973ZM13.6546 29.733L17.1909 33.1627L19.9758 30.2914L16.4395 26.8616L13.6546 29.733ZM19.9758 33.1627L23.512 29.733L20.7272 26.8616L17.1909 30.2914L19.9758 33.1627ZM28 26.2973H22.1196V30.2973H28V26.2973ZM30 24.2973C30 25.4019 29.1046 26.2973 28 26.2973V30.2973C31.3137 30.2973 34 27.611 34 24.2973H30ZM30 4.85937V24.2973H34V4.85937H30ZM28 2.85938C29.1046 2.85938 30 3.75481 30 4.85937H34C34 1.54567 31.3137 -1.14062 28 -1.14062V2.85938ZM8 2.85938H28V-1.14062H8V2.85938Z",
    fill: "white",
    mask: "url(#path-1-inside-1_2873_1802)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2873_1802",
    x: 0,
    y: 0.859375,
    width: 36,
    height: 38.8672,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2873_1802"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2873_1802",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerRed);
export default __webpack_public_path__ + "static/media/map-marker-red.0f734c300f85e2f0238d189c98ed2c68.svg";
export { ForwardRef as ReactComponent };